import React, { useState, useContext } from "react";
import { Card, Button, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import NavbarShop from "./NavbarShop";
import Cart from "./Cart";
import Pins from "./Pins";
import { ShopProvider, ShopContext } from "../contexts/ShopContext";
import Modal from "./Modal";

export default function Shop() {
  const shopCart = useContext(ShopContext);
  return (
    <ShopProvider>
      <NavbarShop />
      <Cart />
      <Pins />
      <Modal/>
      

      <div className="w-100 text-center mt-2"></div>
    </ShopProvider>
  );
}
